import { SpyneTrait } from 'spyne';
import { AIPromptView} from 'components/page-items/ai-prompt-view.js';
import { AiResponsesView } from 'components/page-items/ai-responses-view.js';
import { UtilTraits} from 'traits/util-traits.js';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: false, // IMPORTANT: do not allow raw HTML from models
  breaks: true, // treat single line breaks as <br>
  linkify: false, // no auto-linking
  typographer: false, // no smart quotes
});


export class AIViewTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'aiView$';
    super(context, traitPrefix);
  }

  static aiView$FormatMarkdown(markdownText = ''){

    const updatedMDText = UtilTraits.util$normalizeMarkdown(markdownText);

    return md.render(updatedMDText);
  }


  static aiView$CopyPrompt(){

    const button = this.props.el$('.ai-copy-button').el;
    const selector = button.getAttribute('data-copy-target');
    const container = button.closest('.ai-prompt-card');
    const content = container.querySelector(selector);

    console.log("PROMPT IS ", {button, selector, container, content})

    if (!content) return;

    const text = content.innerText;

    navigator.clipboard.writeText(text).then(() => {
      button.classList.add('copied');
      button.innerText = 'Copied';

      setTimeout(() => {
        button.classList.remove('copied');
        button.innerText = 'Copy';
      }, 1500);
    });

  }

  static aiView$AddPrompt(data = {}){
      //data.promptText = this.aiView$FormatMarkdown(data.promptText);
      data.promptText = UtilTraits.util$normalizeMarkdown(data.promptText);
      this.appendView(new AIPromptView({data}), '.page-heading');

  }

  static aiView$AddResponses(data = {}){
    this.appendView(new AiResponsesView({data}), '.page-content');

  }

  static aiView$AddAIContent(data=this.props.data.aiContent){
    const {prompt, responses} = data;

    this.aiView$AddPrompt(prompt);
    this.aiView$AddResponses(responses);

  }

  static aiView$HelloWorld() {
    return 'Hello World';
  }
}
